(function($) {

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // validador de ruts /////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////
  (function($) {
    jQuery.fn.Rut = function(options) {
      var defaults = {
        digito_verificador: null,
        on_error: function() {},
        on_success: function() {},
        validation: true,
        format: true,
        format_on: 'change'
      };
      var opts = $.extend(defaults, options);
      return this.each(function() {
        if (defaults.format) {
          jQuery(this).bind(defaults.format_on, function() {
            jQuery(this).val(jQuery.Rut.formatear(jQuery(this).val(), defaults.digito_verificador == null));
          });
        }
        if (defaults.validation) {
          if (defaults.digito_verificador == null) {
            jQuery(this).bind('blur', function() {
              var rut = jQuery(this).val();
              if (jQuery(this).val() != '' && !jQuery.Rut.validar(rut)) {
                defaults.on_error();
              } else if (jQuery(this).val() != '') {
                defaults.on_success();
              }
            });
          } else {
            var id = jQuery(this).attr('id');
            jQuery(defaults.digito_verificador).bind('blur', function() {
              var rut = jQuery('#' + id).val() + '-' + jQuery(this).val();
              if (jQuery(this).val() != '' && !jQuery.Rut.validar(rut)) {
                defaults.on_error();
              } else if (jQuery(this).val() != '') {
                defaults.on_success();
              }
            });
          }
        }
      });
    }
  })(jQuery);
  jQuery.Rut = {
    formatear: function(Rut, digitoVerificador) {
      var sRut = new String(Rut);
      var sRutFormateado = '';
      sRut = jQuery.Rut.quitarFormato(sRut);
      if (digitoVerificador) {
        var sDV = sRut.charAt(sRut.length - 1);
        sRut = sRut.substring(0, sRut.length - 1);
      }
      while (sRut.length > 3) {
        sRutFormateado = '.' + sRut.substr(sRut.length - 3) + sRutFormateado;
        sRut = sRut.substring(0, sRut.length - 3);
      }
      sRutFormateado = sRut + sRutFormateado;
      if (sRutFormateado != '' && digitoVerificador) {
        sRutFormateado += '-' + sDV;
      } else if (digitoVerificador) {
        sRutFormateado += sDV;
      }
      return sRutFormateado;
    },
    quitarFormato: function(rut) {
      var strRut = new String(rut);
      while (strRut.indexOf('.') != -1) {
        strRut = strRut.replace('.', '');
      }
      while (strRut.indexOf('-') != -1) {
        strRut = strRut.replace('-', '');
      }
      return strRut;
    },
    digitoValido: function(dv) {
      if (dv != '0' && dv != '1' && dv != '2' && dv != '3' && dv != '4' && dv != '5' && dv != '6' && dv != '7' && dv != '8' && dv != '9' && dv != 'k' && dv != 'K') {
        return false;
      }
      return true;
    },
    digitoCorrecto: function(crut) {
      largo = crut.length;
      if (largo < 2) {
        return false;
      }
      if (largo > 2) {
        rut = crut.substring(0, largo - 1);
      } else {
        rut = crut.charAt(0);
      }
      dv = crut.charAt(largo - 1);
      jQuery.Rut.digitoValido(dv);
      if (rut == null || dv == null) {
        return 0;
      }
      dvr = jQuery.Rut.getDigito(rut);
      if (dvr != dv.toLowerCase()) {
        return false;
      }
      return true;
    },
    getDigito: function(rut) {
      var dvr = '0';
      suma = 0;
      mul = 2;
      for (i = rut.length - 1; i >= 0; i--) {
        suma = suma + rut.charAt(i) * mul;
        if (mul == 7) {
          mul = 2;
        } else {
          mul++;
        }
      }
      res = suma % 11;
      if (res == 1) {
        return 'k';
      } else if (res == 0) {
        return '0';
      } else {
        return 11 - res;
      }
    },
    validar: function(texto) {
      texto = jQuery.Rut.quitarFormato(texto);
      largo = texto.length;
      if (largo < 2) {
        return false;
      }
      for (i = 0; i < largo; i++) {
        if (!jQuery.Rut.digitoValido(texto.charAt(i))) {
          return false;
        }
      }
      var invertido = '';
      for (i = (largo - 1), j = 0; i >= 0; i--, j++) {
        invertido = invertido + texto.charAt(i);
      }
      var dtexto = '';
      dtexto = dtexto + invertido.charAt(0);
      dtexto = dtexto + '-';
      cnt = 0;
      for (i = 1, j = 2; i < largo; i++, j++) {
        if (cnt == 3) {
          dtexto = dtexto + '.';
          j++;
          dtexto = dtexto + invertido.charAt(i);
          cnt = 1;
        } else {
          dtexto = dtexto + invertido.charAt(i);
          cnt++;
        }
      }
      invertido = '';
      for (i = (dtexto.length - 1), j = 0; i >= 0; i--, j++) {
        invertido = invertido + dtexto.charAt(i);
      }
      if (jQuery.Rut.digitoCorrecto(texto)) {
        return true;
      }
      return false;
    }
  };

  $(document).ready(function() {
    //Formateador de ruts
    $('.rut-input').Rut({format_on: 'keyup'});

    if ($('.li-step').length) {
      $('.li-step').mouseenter(function(event) {
        var header,
          paragrapgh;
        header = $(this).data('header');
        paragrapgh = $(this).data('description');

        $(this).find('.description-step').addClass('hovered-list');
        $('#header-step').html(header);
        $('#p-step').html(paragrapgh);
      });

      $('.li-step').mouseleave(function(event) {
        $(this).find('.description-step').removeClass('hovered-list');
      });
    }

    $(window).scroll(function() {
      if ($(this).scrollTop() > 50) {
        $('#breadcrumbs').hide(0, function() {
          $('#proyect_navigator .container-section.bg-nero').css('padding-top', 10);
          $('#proyect_navigator h2').css({'font-size': 20});
          $('#proyect_navigator').animate({
            top: 100
          }, 10, 'linear');
        });
      } else {
        $('#breadcrumbs').show(0, function() {
          $('#proyect_navigator .container-section.bg-nero').css('padding-top', 50);
          $('#proyect_navigator h2').css({'font-size': 32});
          $('#proyect_navigator').animate({
            top: 136
          }, 10, 'linear');
        });
      }
    });

    if ($('#proyect_navigator').length) {
      $('.navigation-scroll').click(function(event) {
        var selectedLi = $(this);
        var scrollTo = selectedLi.data('scroll');
        // change active-a class in order to reflect new selected section
        // $('#proyect_navigator a.active-a').removeClass('active-a');
        // selectedLi.addClass('active-a');
        $('body, html').animate({
          'scrollTop': $(scrollTo).offset().top - 200
        }, 1000)
      });
    }

    //Equalizer igualar alturas
    $('.equal-h').equalizeHeights();

    //Activar tablas responsivas
    if ($('[data-responsive-table]').length) {
      $('[data-responsive-table]').responsiveTables();
      $('[data-responsive-table]').responsiveTablesBreak();
    }

    //Custom checkbox & Radio
    $('[data-cs-checkbox]').customCheckbox({animated: true, direction: 'to-right'});
    $('[data-cs-radio]').customRadioButtons({animated: true, color: true});

    //Equalizar alturas en tiempo real
    if ($(window).width() > 960) {
      $('.tip-box').equalizeHeights();
    } else {
      $('.tip-box').css({'height': 'auto'});
    }

    //Equalizar alturas en tiempo real
    if ($(window).width() <= 768) {
      console.log('test');
      $('.tech-holder').equalizeHeights();
    } else {
      $('.tech-holder').css({'height': 'auto'});
    }

    /* header menu mobile */
    $('.deploy-main-menu').on('click', function() {
      $(this).find('.c-hamburger').toggleClass('is-active');
      $(this).next().find('nav').toggleClass('active');
    });

    $(document).on('click', '.menu-item-has-children', function() {
      $(this).find('.deploy-menu, .sub-menu').toggleClass('active');
    });

    $('.close-cross-suscribe').click(function(event) {
      $('.suscribe-modal').hide();
    });

    $('.suscribe-div').click(function(event) {
      $('.suscribe-modal').show();
    });

    if ($('.home-slider').length) {
      $('.home-slider').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });
    }

    if ($('.projects-slider').length) {
      $('.projects-slider').slick({
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: false
            }
          }, {
            breakpoint: 426,
            settings: {
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false
            }
          }
        ]
      });
    }

    if ($('.terminations-related').length) {
      $('.terminations-related').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<i class="prev-chevron icon-chevron-down"></i>',
        nextArrow: '<i class="next-chevron icon-chevron-down"></i>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    if ($('#related_proyects_slider').length) {
      $('#related_proyects_slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false
            }
          }
        ]
      });
    }

    if ($('#test_slider').length) {
      $('#test_slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false
            }
          }
        ]
      });
    }

    if ($('#holder_bioimagina_slider').length) {
      $('#holder_bioimagina_slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false
            }
          }
        ]
      });
    }

    if ($('#concept_slider').length) {
      $('#concept_slider').slick({
        infinite: true,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<i class="prev-chevron icon-chevron-down"></i>',
        nextArrow: '<i class="next-chevron icon-chevron-down"></i>'
      });
    }

    if ($('#environment_details_slider').length && $(window).width() <= 768) {
      $('#environment_details_slider').slick({
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });

      $('#environment_details_slider').on('afterChange', function() {
        var descriptionEnvMobile = $('.environment-carrousel.slick-active').data('description');
        $('#description_holder').html('<p class=\'animated fadeIn\'>' + descriptionEnvMobile + '</p>');
      })
    }

    if ($('.steps-list').length && $(window).width() <= 768) {
      $('.steps-list').slick({
        infinite: true,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });

      $('.steps-list').on('afterChange', function() {
        var headerStepsMobile = $('.steps-list .li-step.slick-active').data('header');
        var descriptionStepsMobile = $('.steps-list .li-step.slick-active').data('description');
        $('#header-step').html(headerStepsMobile);
        $('#p-step').html(descriptionStepsMobile);
      })
    }

    if ($(window).width() <= 768) {
      $('#mobile_navigation').click(function(event) {
        $('#mobile_navigation_holder').show();
        $('#mobile_current_section i').addClass('rotate-arrow')
      });
      $('#mobile_navigation_holder ul li a').click(function(event) {
        var content = $(this).html().toString();
        $('#mobile_navigation_holder').hide('fast', function() {
          $('#mobile_current_section').html(content + ' <i class=\'icon-chevron-down\'></i>');
        });
      });
    }

    $('.quoation-label').click(function(event) {
      event.stopImmediatePropagation();
    });

    if ($('.dropdown-div, #change_search').length) {
      $('.dropdown-div, #change_search').click(function(event) {
        $('#chevron').toggleClass('rotate-arrow');
        if ($(this).hasClass('active')) {
          $('.dropdown-div, #change_search').toggleClass('active');
          $('#folded_search').hide();
          $('.pushed').removeAttr('style');
        } else {
          $('.dropdown-div, #change_search').toggleClass('active');
          $('#folded_search').show();
          $('.pushed').css('margin-top', $('#folded_search').innerHeight() + 50);
        }
      });
    }

    if ($('.button-pay-or-reserve').length) {
      $('.button-pay-or-reserve').click(function(event) {
        var buttonClicked = $(this);
        if (!buttonClicked.hasClass('active-button-pay-or-reserve')) {
          $('.active-button-pay-or-reserve').removeClass('active-button-pay-or-reserve');
          buttonClicked.addClass('active-button-pay-or-reserve');
        }
      });
    }

    // jQuery UI
    // Configuration for sliders in quotation section
    if ($('#slider_price').length) {
      $('#slider_price').slider({range: 'min'});
    }
    if ($('#slider_subsidy').length) {
      $('#slider_subsidy').slider({range: 'min'});
    }
    if ($('#slider_credit').length) {
      $('#slider_credit').slider({range: 'min'});
    }
    if ($('#slider_years').length) {
      $('#slider_years').slider({range: 'min'});
    }
    if ($('#slider_rate').length) {
      $('#slider_rate').slider({range: 'min'});
    }

    // Configuration of accordion
    if ($('#accordion').length) {
      $('#accordion').accordion();
    }

    if ($('#accordion_faq').length) {
      $('#accordion_faq').accordion({collapsible: true});
    }

    if ($('.map-accordion').length) {
      $('.map-accordion').each(function() {
        $(this).createMapInHolder();
      });
    }

    $('.btn-reserve').click(function(event) {
      console.log('TEST');
      $('.disclaimer-imagina').show();
    });

    $('#button_cancel').click(function(event) {
      $('.disclaimer-imagina').hide();
    });

    if ($('#map_holder').length) {
      var map;
      var myLatLng = {
        lat: -33.452470,
        lng: -70.574416
      };
      map = new google.maps.Map(document.getElementById('map_holder'), {
        center: {
          lat: -33.452470,
          lng: -70.574416
        },
        disableDefaultUI: true,
        zoom: 15,
        scrollwheel: false,
        draggable: false,
        styles: [
          {
            'featureType': 'administrative',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#444444'
              }
            ]
          }, {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers': [
              {
                'color': '#f2f2f2'
              }
            ]
          }, {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          }, {
            'featureType': 'road',
            'elementType': 'all',
            'stylers': [
              {
                'saturation': -100
              }, {
                'lightness': 45
              }
            ]
          }, {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'simplified'
              }
            ]
          }, {
            'featureType': 'road.arterial',
            'elementType': 'labels.icon',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          }, {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          }, {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': [
              {
                'color': '#9b9b9b'
              }, {
                'visibility': 'on'
              }
            ]
          }
        ]
      });
      var marker = new google.maps.Marker({position: myLatLng, map: map, title: 'Hello World!'});
    }

    $('.grid').packery({
      // options
      itemSelector: '.grid-item',
      gutter: 0
    });

    $('i.icon-chevron-down').click(function(event) {
      $(this).toggleClass('rotate-arrow');
    });

    $('a.deploy-menu').click(function(event) {
      $(this).find('i.icon-chevron-down').toggleClass('rotate-arrow');
    });

    $('a.related').featherlightGallery({
      previousIcon: '&#9664;',
      /* Code that is used as previous icon */
      nextIcon: '&#9654;',
      /* Code that is used as next icon */
      galleryFadeIn: 100,
      /* fadeIn speed when slide is loaded */
      galleryFadeOut: 300/* fadeOut speed before slide is loaded */
    });
    $('a.design-district-link').featherlightGallery({
      previousIcon: '&#9664;',
      /* Code that is used as previous icon */
      nextIcon: '&#9654;',
      /* Code that is used as next icon */
      galleryFadeIn: 100,
      /* fadeIn speed when slide is loaded */
      galleryFadeOut: 300/* fadeOut speed before slide is loaded */
    });
    $('a.terminations').featherlightGallery({
      previousIcon: '&#9664;',
      /* Code that is used as previous icon */
      nextIcon: '&#9654;',
      /* Code that is used as next icon */
      galleryFadeIn: 100,
      /* fadeIn speed when slide is loaded */
      galleryFadeOut: 300/* fadeOut speed before slide is loaded */
    });
    $('a.concept').featherlightGallery({
      previousIcon: '&#9664;',
      /* Code that is used as previous icon */
      nextIcon: '&#9654;',
      /* Code that is used as next icon */
      galleryFadeIn: 100,
      /* fadeIn speed when slide is loaded */
      galleryFadeOut: 300/* fadeOut speed before slide is loaded */
    });

    $('.ul-holder-enviroment li').hover(function() {
      var descriptionData = $(this).data('description');
      $('#description_holder').html('<p class=\'animated fadeIn\'>' + descriptionData + '</p>');
    }, function() {});
  });

  $(window).on('load', function() {});

  $(window).on('scroll', function() {
    if ($('#map_and_overview').visible(true)) {
      $('#proyect_navigator li a.active-a').removeClass('active-a');
      $('#proyect_navigator').find('[data-scroll=\'#map_and_overview\']').addClass('active-a');
    }

    if ($('#blueprints').visible(true)) {
      $('#proyect_navigator li a.active-a').removeClass('active-a');
      $('#proyect_navigator').find('[data-scroll=\'#blueprints\']').addClass('active-a');
    }

    if ($('#surroundings').visible(true)) {
      $('#proyect_navigator li a.active-a').removeClass('active-a');
      $('#proyect_navigator').find('[data-scroll=\'#surroundings\']').addClass('active-a');
    }

    if ($('#terminations_holder').visible()) {
      $('#proyect_navigator li a.active-a').removeClass('active-a');
      $('#proyect_navigator').find('[data-scroll=\'#terminations\']').addClass('active-a');
    }

    if ($('#design_district_scroll').visible()) {
      $('#proyect_navigator li a.active-a').removeClass('active-a');
      $('#proyect_navigator').find('[data-scroll=\'#design_district_scroll\']').addClass('active-a');
    }

    if ($('#enviroment_bigger').visible(true)) {
      $('#proyect_navigator li a.active-a').removeClass('active-a');
      $('#proyect_navigator').find('[data-scroll=\'#enviroment_bigger\']').addClass('active-a');
    }

    if ($('#chat_holder').length) {
      if ($(window).scrollTop() > 200) {
        $('#chat_holder h4').fadeOut(0, function() {
          $('#chat_holder').css('padding-left', 0);
          $(this).hide();
        });
      } else {
        $('#chat_holder h4').show().fadeIn(0, function() {
          $('#chat_holder').css('padding-left', '10px');
        })
      }
    }
  });

  $(window).resize(function() {
    if ($('#change_search').length) {
      $('#folded_search').outerWidth($('#change_search').outerWidth());
    }
  });

  $(window).resize(function() {
    if ($('.dropdown-div').length) {
      $('#folded_search').outerWidth($('.dropdown-div').outerWidth());
    }
  });

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Plugins /////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////////////////////////////////////////
  //Igual la altura de las cajas
  $.fn.equalizeHeights = function() {
    var $items = $(this),
      heightArray = [];
    if (!$items.length) {
      return;
    }
    $items.height('auto');
    $items.each(function(index, elem) {
      heightArray.push($(elem).height());
    });
    $items.height(Math.max.apply(Math, heightArray));
    return this;
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  //Responsive tables

  $.fn.responsiveTablesBreak = function() {
    $('[data-responsive-table]').each(function(i, obj) {
      var item = $(obj);
      var itemBreakpoint = item.data('responsive-table');

      if ($(window).width() <= itemBreakpoint) {
        item.addClass('collapsed');
      } else {
        item.removeClass('collapsed');
      }
    });
  }

  $.fn.responsiveTables = function() {
    var item = $(this);
    var itemBreakpoint = item.data('responsive-table');
    var window = $(window);

    if (item.data('responsive-table') === 'collapsed') {
      item.addClass('collapsed');
    } else {
      //Do nothing
    }

    if (window.width() <= itemBreakpoint) {
      item.addClass('collapsed');
    } else {
      item.removeClass('collapsed');
    }

    //tablas responsive
    item.find('tbody td').wrapInner('<span class="td-content">');
    item.find('tbody td').prepend('<span class="th-content"></span>');

    item.find('thead th').each(function(i, obj) {
      var item = $(this);
      var itemCont = item.html();
      item.addClass('objeto-' + i);
    });

    item.find('tbody tr').each(function(i, obj) {
      $(obj).find('td').each(function(iTd, sObj) {
        var infoOriginal = $('.objeto-' + iTd).text();
        var item = $(sObj);
        item.find('.th-content').text(infoOriginal);
      });

    });

  }

  //////////////////////////////////////////////////////////////////////////////////////////////////
  ///Custom checkbox

  $.fn.customCheckbox = function(options) {

    var item = $(this);
    item.wrap('<div class="cs-checkbox-wrap"></div>');

    $('.cs-checkbox-wrap').each(function(i, obj) {
      var item = $(this);
      if (item.find('[data-cs-checkbox]').not('[data-cs-checkbox-disabled]').is(':checked')) {
        item.addClass('active');
      } else {
        item.removeClass('active');
      }
    });

    $(document).on('click', '.cs-checkbox-wrap input[type="checkbox"]', function() {
      var item = $(this);
      if (item.is(':checked')) {
        item.parent().addClass('active');
      } else {
        item.parent().removeClass('active');
      }
    });

    //se definen los valores por defecto en la variable "defaults", luego se definen los elementos a modificar
    //en Settings extendemos el plugin con opcionesm en este caso el valor inicial {} es as� para cuando no viene nada cargado
    //Luego cargamos como par�metro los valores que vienen por defecto y que ser�n modificables y finalmente se define que es parte
    //de las opciones declaradas dentro de la funcion.

    var defaults = {
      animated: true,
      direction: false
    }

    var settings = $.extend({}, defaults, options);

    //Condiciones si en settings el valor dentro de defaults "animated" es verdadero, entonces a�adimos la clase animated
    if (settings.animated) {
      item.parent().addClass('cs-animated');

      switch (settings.direction) {
        case 'to-right':
          item.parent().addClass('cs-to-right');
          break;
        case 'to-left':
          item.parent().addClass('cs-to-left');
          break;
        case 'to-bottom':
          item.parent().addClass('cs-to-bottom');
          break;
        case 'to-top':
          item.parent().addClass('cs-to-top');
          break;
      }

    }

  }

  //////////////////////////////////////////////////////////////////////////////////////////////////
  //Custom radio buttons
  $.fn.customRadioButtons = function(options) {

    var item = $(this);
    item.wrap('<div class="cs-radio-wrap"></div>');

    $('.cs-radio-wrap').each(function(i, obj) {
      var item = $(this);
      if (item.find('[data-cs-radio]').not('[data-cs-radio-disabled]').is(':checked')) {
        item.addClass('active');
      } else {
        item.removeClass('active');
      }
    });

    $('.cs-radio-wrap input[type="radio"]:checked').parent().addClass('active');

    $('.cs-radio-wrap input[type="radio"]').change(function() {
      $('input[name="' + $(this).attr('name') + '"]').each(function() {
        if ($(this).is(':checked')) {
          $(this).parent().addClass('active');
        } else {
          $(this).parent().removeClass('active');
        }
      });
    });

    var defaults = {
      animated: true,
      color: '#000'
    }

    var settings = ({}, defaults, options);

    if (settings.animated) {
      item.parent().addClass('cs-animated');
    }
  }

  $.fn.createMapInHolder = function() {
    var map_holder = $(this);
    var map;
    map = new google.maps.Map(map_holder[0], {
      center: {
        lat: -33.452470,
        lng: -70.574416
      },
      disableDefaultUI: true,
      zoom: 15,
      scrollwheel: false,
      draggable: false,
      styles: [
        {
          'featureType': 'administrative',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#444444'
            }
          ]
        }, {
          'featureType': 'landscape',
          'elementType': 'all',
          'stylers': [
            {
              'color': '#f2f2f2'
            }
          ]
        }, {
          'featureType': 'poi',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        }, {
          'featureType': 'road',
          'elementType': 'all',
          'stylers': [
            {
              'saturation': -100
            }, {
              'lightness': 45
            }
          ]
        }, {
          'featureType': 'road.highway',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'simplified'
            }
          ]
        }, {
          'featureType': 'road.arterial',
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        }, {
          'featureType': 'transit',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        }, {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': [
            {
              'color': '#9b9b9b'
            }, {
              'visibility': 'on'
            }
          ]
        }
      ]
    });
  }
}(jQuery));
